import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { handleHttpError } from '../utils/common';
import useAxios from './useAxios';
import { OnlyFansPayout } from './useMetricsDailyStats';

const useMetricsDailyStatsEarningsAll = (type: 'latest' | 'oneBeforeLatest', userId?: string) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const dialog = useDialog();
    const params = useParams();
    const axios = useAxios();

    // Fetch online users count vs. total sales report
    const fetchData = async (): Promise<OnlyFansPayout.PayoutsStats | null> => {
        const query: string = `${settingsContext.routes.metrics.base}${userId || params.userId}/dailystats/earningsAll/${type}`;

        const data = await axios
            .get(query)
            .then(async response => response.data)
            .catch(error => {
                handleHttpError(error, dialog);

                return null;
            });

        return data;
    };

    return useQuery(
        ['metricsDailyStatsEarningsAll', type, userId || params.userId],
        () => {
            return fetchData();
        },
        {
            refetchOnWindowFocus: false,
            // Stale time 1 hour
            staleTime: 60 * 60 * 1000,
            enabled: userContext.jwtToken && settingsContext.apiKey && (params.userId || userId) ? true : false,
        },
    );
};

export default useMetricsDailyStatsEarningsAll;
